import React from 'react'
import type { Icon } from 'shared/utils'

const Jobs = (props: Icon) => {
    const { color = 'white', size = 24, className = 'jobs' } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            preserveAspectRatio="none">
            <defs>
                <path
                    d="M8.977 5.093c0-.385.313-.698.697-.698h4.652c.384 0 .697.313.697.698v1.395H8.977V5.093zm11.628 1.395h-4.186V5.093A2.095 2.095 0 0 0 14.326 3H9.674a2.095 2.095 0 0 0-2.092 2.093v1.395H3.395C2.625 6.488 2 7.113 2 7.884v11.125c0 .77.625 1.395 1.395 1.395h17.21c.77 0 1.395-.625 1.395-1.395V7.884c0-.771-.625-1.396-1.395-1.396z"
                    id="jobs_svg__a"
                />
            </defs>
            <use xlinkHref="#jobs_svg__a" fillRule="evenodd" />
        </svg>
    )
}

export { Jobs }
